<template>
<div id="apptable" v-cloak>

    <b-card header="Questionari" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-4">
                    <b-button variant="warning" v-on:click="tipologie()">
                        Tipologie Domande
                    </b-button>&nbsp;     
                    <b-button variant="info" v-on:click="analizza()">
                        Analisi risultati
                    </b-button>
                </div>
                <div class="col-md-5 text-right">                    
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                    <template slot="titolo" scope="row">{{row.value}}</template>
                    <template slot="note" scope="row">{{row.value}}</template>
                    <template slot="attivoVis" scope="row">{{row.value}}</template>

                    <template slot="modifica" scope="row">
                        <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                        <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                        <b-btn style="margin:0px 0px 1px 2px;" size="sm" variant="info" @click.stop="domande(row.item,row.index,$event.target)">Domande</b-btn>
                    </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>
    
</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                titolo: {
                    label: 'Titolo',
                    sortable: true
                },
                note: {
                    label: 'Note',
                    sortable: true
                },                
                attivoVis: {
                    label: 'Attivo',
                    sortable: true
                },               
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,            
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        insert() {
            this.$router.push('/app/testataquestionario');
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/testataquestionario/${item.id}`
            });
        },
        domande(item, index, button) {
            this.$router.push({
                path: `/app/dettaglioquestionario/${item.id}`
            });
        },
        analizza(item, index, button) {
            this.$router.push({
                path: `/app/analisirisultati`
            });
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        tipologie() {

            this.$router.push({
               path: `/app/tipologie/`
            });

        },
    },
    created: function () {

        

        if(!ctrlVismenu("Q")){
            this.$router.replace('/accessdenied');
            return;
        }


        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/questionaridomande', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        apptable.items.forEach(function(element, index) {
                            element.attivoVis = (element.flagsta == 'S' ? 'Sì' : 'No');                            
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
